// @flow
import * as React from 'react'
import getAirlines from 'mz-sdk/services/flights/getAirlines'
import { FormattedMessage } from 'mz-intl'
import type { Airline } from 'mz-sdk/services/flights/getAirlines'
import SelectField from '../SelectField'
import EmptySearchResults from '../SelectField/EmptySearchResults'
import { OptionItem } from './elements'
import messages from './messages.intl'

// Types
import type { Props as SelectFieldProps } from '../SelectField'

export type Props = SelectFieldProps & {}

/**
 * Field for selecting airline.
 * For example take a look to attached stories.
 */
class AirlineField extends React.Component<Props> {
  static defaultProps = SelectField.defaultProps

  requestAirlines = (query: string): Promise<Array<Airline>> => {
    const normQuery = query.toLowerCase().trim()
    return getAirlines().then((airlines) => {
      const result = airlines
        .slice()
        .sort((a, b) => a.display.localeCompare(b.display))

      if (!query) {
        return result
      }

      const filtered = result.reduce(
        (acc, airline) => {
          const airlineString = this.renderAirlineToString(
            airline
          ).toLowerCase()
          if (
            airline.display.toLowerCase().startsWith(normQuery) ||
            airline.value.toLowerCase().startsWith(normQuery) ||
            airlineString.startsWith(normQuery)
          ) {
            acc.prefixed.push(airline)
          } else if (
            airline.display.toLowerCase().indexOf(normQuery) >= 0 ||
            airline.value.toLowerCase().indexOf(normQuery) >= 0 ||
            airlineString.indexOf(normQuery) >= 0
          ) {
            acc.others.push(airline)
          }
          return acc
        },
        { prefixed: [], others: [] }
      )

      return [...filtered.prefixed, ...filtered.others]
    })
  }

  renderAirlineToString = (airline: Airline) =>
    `${airline.display} (${airline.value})`

  renderEmpty = (query: string) => {
    if (!query) return null
    return (
      <EmptySearchResults
        query={query}
        emptyResultsMessage={
          <FormattedMessage
            message={messages.NO_AIRLINE_FOUND}
            values={{ query: <b>{query}</b> }}
          />
        }
      />
    )
  }

  renderOption = (airline: Airline) => (
    <OptionItem>{this.renderAirlineToString(airline)}</OptionItem>
  )

  render() {
    return (
      <SelectField
        {...this.props}
        emptyValue={null}
        optionSize={36}
        searchableOptions={{
          ...this.props.searchableOptions,
          requestOptionsOnMount: true,
          requestOptions: this.requestAirlines,
          renderEmpty: this.renderEmpty,
        }}
        renderValue={this.renderAirlineToString}
        renderOption={this.renderOption}
      />
    )
  }
}

export default AirlineField
